import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.COMPANY_FETCH_CONTRIBUTION_VALUES_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
